import React, { useCallback } from 'react'
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { useListFilters } from 'shared/api/list'

export function SelectFilter({
  label,
  filterKey,
  options,
}: {
  label: string
  filterKey: string
  options: { id: string; name: string }[]
}) {
  const {
    filters: { [filterKey]: value },
    setFilter,
  } = useListFilters()
  const onChange = useCallback(
    (e: SelectChangeEvent) => {
      setFilter(filterKey, e.target.value)
    },
    [filterKey, setFilter],
  )
  return (
    <FormControl sx={{ m: 1, width: 150 }}>
      <InputLabel id="selectFilter-label">{label}</InputLabel>
      <Select
        value={value ? String(value) : ''}
        onChange={onChange}
        labelId="selectFilter-label"
        input={<OutlinedInput label={label} />}
      >
        {options.map(({ id, name }) => {
          return (
            <MenuItem key={id} value={id}>
              {name}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export function VerifiedSelect() {
  const {
    filters: { is_verified },
    setFilter,
  } = useListFilters()
  const onSelect = useCallback(
    (e: SelectChangeEvent) => {
      const selectedVal = e.target.value
      switch (selectedVal) {
        case 'true':
          setFilter('is_verified', true)
          return
        case 'false':
          setFilter('is_verified', false)
          return
        default:
          setFilter('is_verified', undefined)
      }
    },
    [setFilter],
  )

  return (
    <FormControl sx={{ m: 1, width: 150 }}>
      <InputLabel id="verifiedSelect-label">Is Verified?</InputLabel>
      <Select
        labelId="verifiedSelect-label"
        id="verifiedSelect"
        value={is_verified ? String(is_verified) : ''}
        onChange={onSelect}
        input={<OutlinedInput label="Is Verified?" />}
        renderValue={(selected) => String(selected)}
      >
        <MenuItem value="undefined">
          <ListItemText primary="both" />
        </MenuItem>
        <MenuItem value="true">
          <ListItemText primary="yes" />
        </MenuItem>
        <MenuItem value="false">
          <ListItemText primary="no" />
        </MenuItem>
      </Select>
    </FormControl>
  )
}
